<template>
	<span>
		<p><span v-if="row.change > 0" style="color: green">&#8593;</span></p>
		<p><span v-if="row.change < 0" style="color: red">&#8595;</span></p>
		<p><span v-if="!row.change"></span></p>
	</span>
</template>

<script>
export default {
	props: {
		row: {
			type: Object,
			required: true,
		},
	},
};
</script>
